/**
 * Survival-mode runtime config — the enemy pool (by tier) and boss roster fed
 * into the pure generateSurvivalWave(). Kept as data so the generator stays
 * injectable/testable. All ids are real enemy/boss defs in src/data/enemies/.
 */
import type { SurvivalEnemyPool } from '@/systems/SurvivalWaveGenerator';
import { BOSS_RUSH_SEQUENCE } from '@/systems/BossRushSequence';

export const SURVIVAL_ENEMY_POOL: SurvivalEnemyPool = {
  // Tier 1 — cannon fodder
  galsia: ['soho-tout', 'platform-tough', 'club-bouncer'],
  // Tier 2 — mid-range
  donovan: ['dockyard-heavy', 'county-enforcer', 'lab-muscle'],
  // Tier 3 — tough
  signal: ['riot-sergeant', 'bailiff-heavy', 'juggernaut'],
  // Mini-boss / elite
  elite: ['praetorian-captain', 'manor-praetorian'],
};

/** Bosses cycled on every SURVIVAL_BOSS_INTERVAL wave (reuses the boss-rush order). */
export const SURVIVAL_BOSS_ROSTER: readonly string[] = BOSS_RUSH_SEQUENCE;
